// components/Hero/Hero.js
import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <div className="hero">
      <div className="hero-content">
        <h1>Welcome to Zyve</h1>
        <p>Why wait for your perfect look? Get the trendiest fashion delivered in flash</p>
      </div>
    </div>
  );
}

export default Hero;